module.exports = __webpack_public_path__ + "img/icon_note_outlined.6efd724a.svg";